<template>
  <div>
    <dr-wrapper v-if="isInEditorMode" v-bind="$props" v-on="wrapOn">
      <v-checkbox
        v-if="!isSwitch"
        :value="false"
        :disabled="isDisabled"
        :class="[evaluateClasses(classes), {'label-reverse': isLeftLabel}]"
        :label="label"
      ></v-checkbox>
      <v-switch
        v-else
        :value="false"
        :disabled="isDisabled"
        :class="[evaluateClasses(classes), {'label-reverse': isLeftLabel}]"
        :label="label"
      ></v-switch>
    </dr-wrapper>
    <template v-else-if="isVisible">
      <v-checkbox
        v-if="!isSwitch"
        v-model="value"
        ref="drCheckboxRef"
        :disabled="isDisabled"
        :rules="_isRequiredField"
        :class="[evaluateClasses(classes), {'label-reverse': isLeftLabel}]"
        :label="label"
        @change="invokeActionOnClick(model.GenerationOnChange, { value: $event })"
      ></v-checkbox>
      <v-switch
        v-else
        v-model="value"
        ref="drCheckboxRef"
        :disabled="isDisabled"
        :class="[evaluateClasses(classes), {'label-reverse': isLeftLabel}]"
        :rules="_isRequiredField"
        :label="label"
        @change="invokeActionOnClick(model.GenerationOnChange, { value: $event })"
      ></v-switch>
    </template>
    
  </div>
</template>

<script>
import inputWidgetsWrapperMixin from '../../mixins/input-widgets-wrapper-mixin'
import baseMixin from '../../mixins/base-mixin'
import inputMixin from '../../mixins/input-mixin'
import actionMixin from '../../mixins/actions-mixin'
import inputWidgetsValidateMixin from '../../mixins/input-widgets-validate-mixin'

export default {
  mixins: [baseMixin, inputMixin, actionMixin, inputWidgetsWrapperMixin, inputWidgetsValidateMixin],
  computed: {
    _isRequiredField() {
      if (!this.model.Required) {
        return []
      }
      return [val => typeof val === 'boolean' || this.$t('vuetifyWidgets.dr-text-field.required')]
    },
    value: {
      get() {
        return typeof this.getDataSourceField(this.model.Value) === 'string' ? 
          false : this.getDataSourceField(this.model.Value)
      },
      set(v) {
        this.setDataSourceField(this.model.Value, v)
      }
    },
    label() {
      return this.evaluateExpression(this.model.Caption)
    },
    isSwitch() {
      return this.model.switchMode
    },
    isLeftLabel() {
      return this.model.CaptionPosition === 'left'
    }
  }
}
</script>
<style>
.label-reverse .v-input__slot > .v-label {
  flex: inherit !important;
}

.label-reverse .v-input__slot {
  flex-direction: row-reverse;
  justify-content: flex-end;
}

.label-reverse .v-input--selection-controls__input {
  margin-right: 0;
  margin-left: 8px;
}
</style>